import { useMutation, useQuery } from 'react-query'
import { endpoints } from '@app/api/config'
import { apiAuthClient } from '@app/services/apiAuthClient'
import { AxiosResponse } from 'axios'
import { ApiErrorResponse } from 'BackendApi'
import { getRandomExampleHeader } from '@app/api/utils/mock'

export type ApiPlanAvailable = {
  result: boolean
  code?: string
  message?: string
}

type ApiPlanAvailableResponse = {
  data: ApiPlanAvailable
}

const getPlanAvailable = async (planId: string) => {
  const apiResponse: AxiosResponse<ApiPlanAvailableResponse> =
    await apiAuthClient.get(endpoints.planAvailable, {
      params: { planId },
      headers: {
        ...getRandomExampleHeader([
          'Plan is available',
          // 'In case of mtu exceeded',
        ]),
      },
    })

  return apiResponse.data.data
}

export const useCheckPlanAvailability = (planId: string) =>
  useQuery<ApiPlanAvailable, ApiErrorResponse>(
    ['app', planId],
    () => getPlanAvailable(planId),
    {
      staleTime: 2 * 60 * 1000, // 2 mins in ms,
      enabled: !!planId,
    }
  )

export const useCheckPlanAvailabilityMutate = (planId: string) =>
    useMutation<ApiPlanAvailable, ApiErrorResponse>(
        ['app', planId],
        () => getPlanAvailable(planId)
    )